const OrderList = () => import('./OrderList.vue')
const TelDetail = () => import('./TelDetail.vue')
const DocDetail = () => import('./DocDetail.vue')
const OrderEvaluate = () => import('./OrderEvaluate.vue')
const LetterDetail = () => import('./LetterDetail.vue')
const LawsuitDetail = () => import('./LawsuitDetail.vue')
const FaceDetail = () => import('./FaceDetail.vue')
const DraftDetail = () => import('./DraftDetail.vue')

export {
  OrderList,
  TelDetail,
  DocDetail,
  OrderEvaluate,
  LetterDetail,
  LawsuitDetail,
  FaceDetail,
  DraftDetail
}



// WEBPACK FOOTER //
// ./src/pages/order/index.js